// extracted by mini-css-extract-plugin
module.exports = {"root":"DlpBoatTypes_root__E3wxd","header":"DlpBoatTypes_header__eutwP","buttonsDesktop":"DlpBoatTypes_buttonsDesktop__odYZ_","button":"DlpBoatTypes_button__kdzSf"};